"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validation_1 = require("../../validation");
const ItemDefinition_1 = require("./ItemDefinition");
const zod_1 = require("zod");
const configSchema = zod_1.z.object({ value: zod_1.z.string().optional() });
const dataSchema = zod_1.z.object({
    value: zod_1.z.string((0, validation_1.labelZodErrors)("Date")).date("Must choose a valid date."),
});
exports.default = new ItemDefinition_1.ItemDefinition("Date", configSchema, dataSchema, new validation_1.ValidatorPipeline("Date Config Validator", []), new validation_1.ValidatorPipeline("Date Data Validator", []));
//# sourceMappingURL=Date.js.map